import React, { useState, useEffect } from 'react';
import { CircularProgress, Paper, useMediaQuery, IconButton } from "@material-ui/core";
import config from './config.json';
import { customTheme } from "./customTheme";
//import { useNotify } from "react-admin";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Underground from './images/underground.png'
import Light from './images/lights.png';
import Elevator from './images/elevator.png';
import Evcharging from './images/evcharging.png';
import Barrier from './images/barrier.png';
import Multilevel from './images/multilevel.png';
import Security from './images/security.png';
import SecurityCamera from './images/cctv.png'
import LocationInput from './components/locationInput';
import { useHistory } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import EditIcon from '@material-ui/icons/Edit';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const ParkingProfile = () => {
    //const notify = useNotify()
    const history = useHistory()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [parkingInfo, setParkingInfo] = useState("")
    const [parkingInfoImage, setParkingInfoImage] = useState([])
    const [loading, setLoading] = useState(false)
    let defaultImg = "https://images.parksmart.in/main/Images/ParkingImages/default_parking.jpg"

    const getParkingInfo = () => {
        setLoading(true)
        const requestBody = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        };
        fetch(`${config.HOST_NAME}/crm/v3/user/profile`, requestBody)
            .then(res => {
                saveTokens(res)
                return res.json()
            })
            .then((json) => {
                if (json.success) {
                    setLoading(false)
                    let parkingImage = [defaultImg];
                    if (json.data.parking_images) {
                        const jsonImg = JSON.parse(json.data.parking_images);
                        if (Array.isArray(jsonImg) && jsonImg.length > 0) {
                            parkingImage = jsonImg;
                        }
                    }
                    setParkingInfoImage((prev) => {
                        return parkingImage.map((img) => {
                            return <div>
                                <img src={img} alt="ParkingImage" style={{ width: "100%", height: "240px", borderRadius: 10, marginBottom: 30 }} />
                            </div>
                        })
                    })
                    setParkingInfo(json.data)
                } else {
                    setLoading(false)
                    notify(json.message, "warning")
                }
            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
                notify("Something Went Wrong", "warning")
            })
    }

    useEffect(() => {
        getParkingInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <Paper style={{ display: loading ? "flex" : "block", justifyContent: "center", alignItems: "center", padding: isSmallDevice ? "0 22px 25px" : "25px 22px", boxShadow: isSmallDevice ? "none" : undefined, height: loading || isSmallDevice ? "900px" : "600px" }}>

            {loading && !parkingInfo.access_key &&
                <div>
                    <CircularProgress />
                </div>
            }
            {
                !loading && parkingInfo.access_key &&

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 30rem))", gap: 30 }}>

                    {/* Parking Info */}
                    <div className='bookingScroll'>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <h1 style={{ fontSize: 22, lineHeight: "1px" }}>{parkingInfo.name}</h1>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    {/* <IconButton style={{ color: "#18cc69" }} onClick={() => history.push(`/parking/profile/user`)}> <PersonIcon /></IconButton> */}
                                    <IconButton style={{ color: "#18cc69" }} onClick={() => history.push(`/parking/profile/info/${parkingInfo.id}`)}> <EditIcon /></IconButton>
                                </div>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <p style={{ fontSize: 14, color: "#18cc69" }}>{parkingInfo.parking_type}</p>
                                <div style={{ fontSize: 14, color: parkingInfo.approved === 1 ? "#18cc69" : "#de575e", display: 'flex', alignItems: "center" }}>
                                    <div style={{ width: 10, height: 10, marginRight: 8, borderRadius: 10, backgroundColor: parkingInfo.approved === 1 ? "#18cc69" : "#de575e" }} />
                                    {parkingInfo.approved === 1 ? "Active" : "Inactive"}</div>
                            </div>

                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <div style={{ width: "25px", display: "flex", justifyContent: "center", alignItems: "center", padding: "5px", boxShadow: "rgba(0, 0, 0, 0.15) -.2px 2.4px 3.2px", borderRadius: 5 }}>
                                    <LocationOnIcon className="locationIcon" />
                                </div>

                                <div style={{ marginLeft: 10 }}>
                                    <p style={{ fontSize: 14, color: "#9899A1" }}>{parkingInfo.parking_address}</p>
                                </div>
                            </div>
                        </div>

                        <p style={{ fontWeight: "600" }} >Facilities </p>


                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#9899A1" }}>
                            <div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={Underground} alt="Icon" />
                                    {parkingInfo.underground_parking === 1 ? <span>Underground</span> : <del>Underground</del>}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={Multilevel} alt="Icon" />
                                    {parkingInfo.multilevel_parking === 1 ? <span>Multilevel</span> : <del>Multilevel</del>}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={Barrier} alt="Icon" />
                                    {parkingInfo.boom_barrier === 1 ? <span>Boom Barrier</span> : <del>Boom Barrier</del>}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={Elevator} alt="Icon" />
                                    {parkingInfo.lift === 1 ? <span>Lift</span> : <del>Lift</del>}
                                </div>

                            </div>
                            <div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={Light} alt="Icon" />
                                    {parkingInfo.proper_lighting === 1 ? <span>Lighting</span> : <del>Lighting</del>}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={SecurityCamera} alt="Icon" />
                                    {parkingInfo.security_camera === 1 ? <span>Security Camera</span> : <del>Security Camera</del>}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={Security} alt="Icon" />
                                    {parkingInfo.security_guard === 1 ? <span>Security Guard</span> : <del>Security Guard</del>}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    fontSize: 12,

                                }}>
                                    <img style={{ width: "30px" }} src={Evcharging} alt="Icon" />
                                    {parkingInfo.electric_charging === 1 ? <span>EV Charging</span> : <del>EV Charging</del>}
                                </div>
                            </div>
                        </div>


                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <p style={{ fontWeight: "600" }} >User Details </p>
                            <IconButton style={{ color: "#18cc69" }} onClick={() => history.push(`/parking/profile/user`)}> <EditIcon /></IconButton>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#9899A1", fontSize: 12, padding: "0px 8px" }}>
                            <div>
                                <p>Name </p>
                                <p>Display Name</p>
                                <p>Email</p>
                                <p>Mobile</p>
                            </div>
                            <div>
                                <p>{sessionStorage.getItem('full_name')} </p>
                                <p>{sessionStorage.getItem('display_name')}</p>
                                <p>{sessionStorage.getItem('email')}</p>
                                <p>{sessionStorage.getItem('mobile')}</p>
                            </div>
                        </div>
                    </div>

                    {/* Image of Parking */}

                    <div style={{ width: "100%", height: "250px" }}>
                        <Slider>{parkingInfoImage}</Slider>
                        {/* <img style={{ width: "100%", height: "100%", borderRadius: 10, marginBottom: 30 }} src={parkingInfoImage} alt="Parking Images" /> */}


                        <LocationInput latitudeSource={parkingInfo.parking_latitude} longitudeSource={parkingInfo.parking_longitude} />

                    </div>
                </div>
            }
        </Paper>
    )
}

export default ParkingProfile